// @flow
/* eslint-disable import/prefer-default-export */
import * as cc from 'common/constants';
import { getStorageItem, setStorageItem, removeStorageItem } from 'common/utils/StorageApi';
import { Settings } from 'settings';

import { castDataToAuthData } from '../utils';
import type { AuthData } from '../models/AuthData';
import type { User } from '../models/User';

export function getAuthData(): AuthData {
  const auth = getStorageItem('auth');

  if (!auth) {
    throw new Error('Auth data not found in LocalStorage');
  }

  return castDataToAuthData(auth);
}

export function saveAuthData(authData: AuthData): AuthData {
  setStorageItem('auth', {
    token_type: authData.type,
    expires_in: authData.expiresIn,
    access_token: authData.accessToken,
    refresh_token: authData.refreshToken,
  });

  return authData;
}

export function removeAuthData(): void {
  removeStorageItem('auth');
}

export function setBridge(data: {}): void {
  setStorageItem('sf2to1', data);
}

export function removeBridge(): void {
  removeStorageItem('sf2to1');
}

export function syncSettings(app: cc.AppName, data: User) {
  if (data.id != null && getStorageItem(`@${app}/userId`) !== data.id) {
    setStorageItem(`@${app}/userId`, data.id);
    Settings.destroy();
  } else {
    Settings.sync();
  }

  return data;
}



// WEBPACK FOOTER //
// ./src/modules/auth/services/StorageApiService.js